<template>
  <q-page v-if="adr" class="main-wrapper-page single-page adr" style="background-color: var(--q-accent)">
    <div class="row q-col-gutter-lg no-wrap adr-sidebar">
      <div class="col col-3">
        <p><b>Number:</b> {{ adr.adrId }}</p>
        <p v-if="adr.snowSysId">
          <b>View & Export in SNOW:</b>
          <a class="snow-link" :href="snowLink" target="_blank">{{ adr.snowSysId }}</a>
        </p>
        <p><b>Category:</b> {{ adr.category }}</p>
        <p><b>Scope:</b> {{ adr.scope.units }}, {{ adr.scope.regions }}</p>
        <p><b>Status:</b> {{ adr.status }}</p>
        <p><b>Valid date:</b> {{ adr.validDate }}</p>
        <p><b>Version:</b> {{ adr.version }}</p>
        <p><b>Metrics Implemented:</b> {{ adr.constraintsImplemented }}</p>
        <p><b>Constraints Implemented:</b> {{ adr.metricsImplemented }}</p>
        <p v-if="adr.infraServices?.length">
          <b>Related Infra Services:</b>
          <template v-for="(service, index) in adr.infraServices" :key="index + service.apmid">
            <span v-if="service.apmid && service.apmid !== 'NULL'"
              ><router-link class="q-ml-sm" :to="`/services/${service.id}`" target="_blank">
                {{ service.displayName || service.apmid }} </router-link
              >,
            </span>
          </template>
        </p>
        <p v-if="adr.relatedADRs?.length">
          <b>Related ADRs:</b>
          <router-link
            class="q-ml-sm"
            v-for="(relatedADR, index) in adr.relatedADRs"
            :key="index + relatedADR.adrId"
            :to="`/adrs/${relatedADR.adrId}`"
            target="_blank"
          >
            {{ relatedADR.adrId || relatedADR.name }}
          </router-link>
        </p>
        <p v-if="adr.owners?.length"><b>Owners:</b> {{ adr.owners.map((o) => o.name).join(', ') }}</p>
      </div>
      <div class="col col-9">
        <q-scroll-area
          :thumb-style="{
            borderRadius: '5px',
            width: '3px',
            background: '#9f9f9f',
            height: '3px',
            zIndex: 999999,
            opacity: 1,
          }"
          :style="`height: calc(100vh - ${currentBanner ? '190px' : '140px'})`"
        >
          <div v-if="isAllContentPropertiesAbsent" class="single-page-markdown q-pr-md" v-html="content"></div>
          <div class="single-page-markdown q-pr-md" ref="adrContentHtmlContainer">
            <template v-if="amendment">
              <h3>Amendment</h3>
              <div v-html="amendment"></div>
            </template>
            <h3>Target audience</h3>
            <div v-html="targetAudience"></div>
            <h3>Context</h3>
            <div v-html="context"></div>
            <h3>Decision</h3>
            <div v-html="decision"></div>
            <h3>Requirements</h3>
            <div v-html="requirements"></div>
            <h3>Constraints</h3>
            <div v-html="constraints"></div>
            <h3>Metrics</h3>
            <div v-html="metrics"></div>
          </div>
        </q-scroll-area>
      </div>
    </div>
  </q-page>
</template>

<script>
import apollo from '@/library/http/apollo';
import gql from 'graphql-tag';
import { marked } from 'marked';
import { mapGetters } from 'vuex';
import { BANNERS_GETTERS } from '@/store/modules/banners';

export default {
  name: 'AdrPage',
  data() {
    return {
      adr: undefined,
    };
  },
  async mounted() {
    const id = this.$route.params.id;
    await this.getAdrData(id);
  },
  computed: {
    ...mapGetters('banners', {
      currentBanner: BANNERS_GETTERS.BANNERS_SHOW,
    }),
    snowLink() {
      return `${process.env.VUE_APP_SNOW_URL}/nav_to.do?uri=sn_compliance_policy.do?sys_id=${this.adr.snowSysId}%26sysparm_view=sr_adr`;
    },
    isAllContentPropertiesAbsent() {
      return !(
        this.adr?.amendment ||
        this.adr?.constraints ||
        this.adr?.context ||
        this.adr?.decision ||
        this.adr?.requirements ||
        this.adr?.targetAudience ||
        this.adr?.metrics
      );
    },
    amendment() {
      if (!this.adr?.amendment) return '';
      return marked(this.adr.amendment);
    },
    constraints() {
      if (!this.adr?.decision) return '';
      return marked(this.adr.constraints);
    },
    context() {
      if (!this.adr?.context) return '';
      return marked(this.adr.context);
    },
    decision() {
      if (!this.adr?.decision) return '';
      return marked(this.adr.decision);
    },
    requirements() {
      if (!this.adr?.requirements) return '';
      return marked(this.adr.requirements);
    },
    targetAudience() {
      if (!this.adr?.targetAudience) return '';
      return marked(this.adr.targetAudience);
    },
    metrics() {
      if (!this.adr?.metrics) return '';
      return marked(this.adr.metrics);
    },
    content() {
      if (!this.adr?.content) return '';
      return marked(this.adr.content);
    },
  },
  methods: {
    async getAdrData(id) {
      this.$showLoading();
      try {
        await apollo.apolloClient
          .query({
            query: gql`
            query {
              getADRs(filter: {filterBy: {adrId: "${id}"}, includeFields: {services: true, owners: true, relatedADRs: true}}) {
                adrs {
                  adrId
                  snowSysId
                  category
                  id
                  created_at
                  name
                  scope
                  status
                  validDate
                  version
                  content
                  constraintsImplemented
                  metricsImplemented
                  amendment
                  constraints
                  context
                  decision
                  requirements
                  targetAudience
                  metrics
                  relatedADRs {
                    adrId
                  }
                  infraServices {
                    id
                    apmid
                    displayName
                  }
                  owners {
                    name
                    email
                  }
                }
              }
            }
          `,
          })
          .then(async (response) => {
            this.adr = response.data.getADRs.adrs[0];
          });
      } catch (error) {
        this.$notify('negative', 'Error', error.message);
      } finally {
        this.$hideLoading();
      }
    },
  },
};
</script>

<style lang="scss">
.adr {
  img {
    max-width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.adr-sidebar {
  p {
    margin-bottom: 5px;
    overflow-wrap: anywhere;
  }
}
.snow-link {
  display: block;
}
</style>
